export default new class CommentsIcon {
  constructor() {
    this.articleCommentIcon = '.post-stats._comments';
    this.newsCardCommentIcon = '.news-card__stat';
    this.disqusCommentsBlock = '.disqus-comments';
    this.commentsGetParam = '?comments';

    if ($(this.articleCommentIcon).length || $(this.newsCardCommentIcon).length) {
      this.bindEvents();
      this.detectIsScrollToCommentNeed();
    }
  }

  bindEvents() {
    $(document)
      .on('click', this.articleCommentIcon, () => {
        this.scrollToComments();
      });
  }

  detectIsScrollToCommentNeed() {
    if (window.location
      .href.indexOf(this.commentsGetParam) > -1) {
      this.scrollToComments();
    }
  }

  scrollToComments() {
    $('html, body').stop().animate({
      scrollTop: $(this.disqusCommentsBlock).offset().top - 50,
    }, 800);
  }
}();
